<script lang="ts">
  import { cn } from '$lib/utils';
</script>

<div class={cn('flex flex-1 items-center justify-between space-x-2 justify-end')}>
  <slot />
</div>
